import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {AuthProvider} from './hooks/useAuth';
import ScrollToTop from './utils/ScrollToTop';
import EffectsController from './effects';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter future={{v7_startTransition: true, v7_relativeSplatPath: true}}>
        <EffectsController />
        <ScrollToTop />
        <App />
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

// Falls du Performance messen willst
reportWebVitals();
